import { render, staticRenderFns } from "./pc-side-feature.vue?vue&type=template&id=7964d98e&"
import script from "./pc-side-feature.vue?vue&type=script&lang=js&"
export * from "./pc-side-feature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports